import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Dashboard from './Dashboard';
import SignUpPage from './SignUpPage';
import SignInPage from './SignInPage';
import OnboardPage from './OnboardPage';
import SummaryPage from './SummaryPage';
import GoalPage from './GoalPage';
import OverviewPage from './OverviewPage';
import EngineeringPage from './EngineeringPage';
import DataInputPage from './DataInputPage';
import DataProcessingPage from './DataProcessingPage';
import DataAugmentationPage from './DataAugmentationPage';
import MachineLearningPage from './MachineLearningPage';
import OutputPage from './OutputPage';
import ProfilePage from './ProfilePage';
import SettingsPage from './ProfileSettingPage';
import VisualizationPage from './VisualizationPage';
import RecommendationPage from './RecommandationPage';
import GraphModelPage from './GraphModelPage';
import AssemblyLinePage from './AssemblyLine';
import RecommendationOutput from './RecommandationOutput';
import GraphModelOutput from './GraphModelOutput';
import CarbonMeasurementPage from './CarbonMeasurement';
import CarbonReportingPage from './CarbonReporting';
import CustomVisualizationPage from './CustomVisualization';
import StandardVisualizationPage from './StandardVisualization';
import MLRequestsPage from './MLRequestsPage';
import MLActivePage from './MLActivePage';
import MarketplacePage from './MarketplacePage';
import MarketplaceDERPage from './MarketplaceDER';
import MarketplaceConstructionPage from './MarketplaceConstruction';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
            <Routes>
              <Route path='/' element={<SignInPage />} />
              <Route path='/SignUp' element={<SignUpPage />} />
              <Route path='/Onboard' element={<OnboardPage />} />
              <Route path='Dashboard' element={<Dashboard />} >
                <Route  path='Welcome' element={<SummaryPage />} />
                {/* <Route  path='Goal' element={<GoalPage />} /> */}
                <Route  path='Overview' element={<OverviewPage />} />      
                <Route  path='Engineering' element={<EngineeringPage />} />
                  {/* <Route  path='/Dashboard/Engineering/Input' element={<DataInputPage />} /> */}
                  <Route  path='/Dashboard/Engineering/Processing' element={<DataProcessingPage />} />
                  <Route  path='/Dashboard/Engineering/Augmentation' element={<DataAugmentationPage />} />
                <Route  path='Carbon' element={<CarbonMeasurementPage />} />
                  <Route  path='/Dashboard/Carbon/Reporting' element={<CarbonReportingPage />} />
                <Route  path='Visualization' element={<StandardVisualizationPage />} />
                  <Route  path='/Dashboard/Visualization/CustomVisualization' element={<CustomVisualizationPage />} />
                  {/* <Route  path='/Dashboard/Visualization/StandardVisualization' element={<StandardVisualizationPage />} /> */}
                <Route  path='ML' element={<MachineLearningPage />} />
                  {/* <Route  path='/Dashboard/ML/Recommendation' element={<RecommendationPage />} />
                  <Route  path='/Dashboard/ML/GraphModel' element={<GraphModelPage />} /> */}
                  <Route  path='/Dashboard/ML/Requests' element={<MLRequestsPage />} />
                  <Route  path='/Dashboard/ML/Assembly' element={<AssemblyLinePage />} />
                  <Route  path='/Dashboard/ML/Active' element={<MLActivePage />} />
                <Route  path='Output' element={<OutputPage />} />
                  {/* <Route  path='/Dashboard/Output/Recommendation' element={<RecommendationOutput />} />
                  <Route  path='/Dashboard/Output/GraphModel' element={<GraphModelOutput />} /> */}
                <Route  path='Marketplace' element={<MarketplacePage />} />
                  {/* <Route  path='/Dashboard/Marketplace/DER' element={<MarketplaceDERPage />} />
                  <Route  path='/Dashboard/Marketplace/Construction' element={<MarketplaceConstructionPage />} /> */}
                <Route  path='Profile' element={<ProfilePage />} />
                  <Route  path='/Dashboard/Profile/Settings' element={<SettingsPage />} />
              </ Route>
            </Routes>
          </Router>      
  </React.StrictMode>
);
